module.exports = __webpack_public_path__ + "img/img4.21aa2b8e.png";